import { Purchases, LOG_LEVEL } from '@revenuecat/purchases-capacitor';
import { isNative } from './platform';

const REVENUECAT_APPLE_API_KEY = import.meta.env.VITE_REVENUECAT_APPLE_API_KEY || 'appl_placeholder';
const REVENUECAT_GOOGLE_API_KEY = import.meta.env.VITE_REVENUECAT_GOOGLE_API_KEY || 'goog_placeholder';

export const configurePurchases = async (userId) => {
    if (!isNative()) return;

    try {
        // 1. Determine platform API key
        const isIos = window.Capacitor?.getPlatform() === 'ios';
        const apiKey = isIos ? REVENUECAT_APPLE_API_KEY : REVENUECAT_GOOGLE_API_KEY;

        if (!apiKey || apiKey.includes('placeholder')) {
            console.warn("[RevenueCat] API Key is missing or placeholder. Skipping initialization.");
            return;
        }

        // 2. Enable debug logging in development mode
        if (import.meta.env.DEV) {
            await Purchases.setLogLevel({ level: LOG_LEVEL.DEBUG });
        }

        // 3. Configure RevenueCat SDK
        await Purchases.configure({ apiKey });
        console.log("[RevenueCat] SDK configured successfully.");

        // 3. Link logged-in user ID
        if (userId) {
            const { customerInfo } = await Purchases.logIn({ appUserID: userId });
            console.log("[RevenueCat] User identified:", userId, customerInfo);
        }
    } catch (e) {
        console.error("[RevenueCat] Configuration failed:", e);
    }
};

export const purchasesLogOut = async () => {
    if (!isNative()) return;
    try {
        await Purchases.logOut();
        console.log("[RevenueCat] User logged out.");
    } catch (e) {
        console.error("[RevenueCat] Logout failed:", e);
    }
};

export const getOfferings = async () => {
    if (!isNative()) return null;
    try {
        const offerings = await Purchases.getOfferings();
        if (offerings.current !== null && offerings.current.availablePackages.length !== 0) {
            return offerings.current.availablePackages;
        }
        return [];
    } catch (e) {
        console.error("[RevenueCat] Failed to fetch offerings:", e);
        return [];
    }
};

export const purchasePackage = async (pack) => {
    if (!isNative()) throw new Error("In-app purchases are only available on mobile devices.");
    try {
        const { customerInfo } = await Purchases.purchasePackage({ aPackage: pack });
        return customerInfo;
    } catch (e) {
        if (e.userCancelled) {
            return null; // Return null if user simply cancelled the sheet
        }
        throw e;
    }
};

export const restorePurchases = async () => {
    if (!isNative()) return null;
    try {
        const customerInfo = await Purchases.restorePurchases();
        return customerInfo;
    } catch (e) {
        console.error("[RevenueCat] Restore failed:", e);
        throw e;
    }
};
